module.exports = __webpack_public_path__ + "static/store-66631c91f9a56e810c57f7067405a2c2.svg";